import { useState } from 'react'

import { useToast } from '@percent/lemonade'
import { APIErrorHandler } from '@percent/partner-dashboard/common/library/APIErrorHandler'
import { dayJS } from '@percent/partner-dashboard/common/library/utility/date'
import { DonationListStatusFilterEnum } from '@percent/partner-dashboard/services/donation/donationService.types'
import { FetchDonationCSVType, UseCSVDownloaderPropsType } from './useCSVDownloader.types'
import { downloadCsvFile } from '@percent/partner-dashboard/common/library/utility/utility'

export const useCSVDownloader = ({ service, fileName, successMessage }: UseCSVDownloaderPropsType) => {
  const [loading, setLoading] = useState(false)
  const [errorCSVMessage, setErrorCSVMessage] = useState('')
  const { addToast } = useToast()

  const fetchDonationCSV = async (csvParamData: FetchDonationCSVType) => {
    setLoading(true)
    setErrorCSVMessage('')

    try {
      const start = dayJS(csvParamData?.startDate).format()
      const end = dayJS().isSame(dayJS(csvParamData?.endDate), 'd')
        ? dayJS().utc().format()
        : dayJS(csvParamData?.endDate).utc().endOf('day').format()
      const csvData = await service({
        start,
        end,
        ...(csvParamData?.status && {
          status: csvParamData?.status.filter((s): s is DonationListStatusFilterEnum => Boolean(s))
        }),
        ...(csvParamData?.kinds && {
          kinds: csvParamData?.kinds
        }),
        ...(csvParamData?.query && {
          query: csvParamData?.query
        }),
        ...(csvParamData?.fundraiserId && {
          fundraiserId: csvParamData?.fundraiserId
        })
      })
      downloadCsvFile(csvData, fileName(start, end))
      addToast(successMessage, 'success')
    } catch (err) {
      setErrorCSVMessage(APIErrorHandler(err?.response?.data?.error))
    } finally {
      setLoading(false)
    }
  }

  return [
    {
      loading,
      errorCSVMessage
    },
    {
      fetchDonationCSV
    }
  ]
}
